import { getErrorDescription, getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { computed, makeObservable } from "mobx";
import { parseBet } from "./parseBet";
import { createLoadMoreRequest } from "./createLoadMoreRequest";
import { parseCashOut } from "./parseCashOut";
import { parseSettlementStatus } from "./parseSettlementStatus";
import { formatLoadBetsTrackingData, Tracker } from "../helpers";
import { telemetry } from "../constants";
import { formatAmountWrapper } from "./formatAmount";
export class Parser {
    constructor(options) {
        this.clearBets = () => {
            this.retriever.clearBets();
        };
        this.retriever = options.retriever;
        this.teamLogos = options.teamLogos;
        this.dictionary = options.dictionary;
        this.currencyCodeMap = options.currencyCodeMap;
        this.currencyFormatter = options.currencyFormatter;
        this.dateFormatter = options.dateFormatter;
        this.formatDateToFullMonthDayYear = options.formatDateToFullMonthDayYear;
        this.openModal = options.openModal;
        this.openPromosPage = options.openPromosPage;
        this.isLoggedInCanBet = options.isLoggedInCanBet;
        this.openRecheckLocationModal = options.openRecheckLocationModal;
        this.staticS3Host = options.staticS3Host;
        this.swooshFeatureFlag = options.swooshFeatureFlag;
        this.swooshBaseUrl = options.swooshBaseUrl;
        this.openBetOverMaxAmountModal = options.openBetOverMaxAmountModal;
        this.locale = options.locale;
        makeObservable(this, {
            bets: computed.struct,
            status: computed
        });
    }
    activate() {
        this.retriever.activate();
    }
    deactivate() {
        this.retriever.deactivate();
    }
    loadMoreBets({ status, previousStatus, count, toggleCashOutSubscriptions, action, }) {
        Tracker.getInstance().trackEvent(telemetry.events.myBets, formatLoadBetsTrackingData({
            action,
            status,
            previousStatus,
            bets: this.retriever.bets,
            events: this.retriever.events,
        }));
        this.retriever.loadMoreBets(createLoadMoreRequest(status, count, this.retriever.skip()), toggleCashOutSubscriptions);
    }
    get bets() {
        const bets = [];
        const retrieverBets = [...this.retriever.bets.values()];
        retrieverBets.forEach(retrieverBet => {
            try {
                const bet = parseBet({
                    bet: retrieverBet,
                    events: this.retriever.events,
                    cashOut: parseCashOut({
                        retriever: this.retriever,
                        dictionary: this.dictionary,
                        formatAmount: formatAmountWrapper(this.currencyCodeMap, this.currencyFormatter, retrieverBet.currency),
                        information: this.retriever.cashOutInformations.get(retrieverBet.betId),
                        operation: this.retriever.cashOutOperations.get(retrieverBet.betId),
                        isLoggedInCanBet: this.isLoggedInCanBet,
                        openRecheckLocationModal: this.openRecheckLocationModal,
                        betStatus: parseSettlementStatus(retrieverBet.settlementStatus),
                    }),
                    teamLogos: this.teamLogos,
                    staticS3Host: this.staticS3Host,
                    dictionary: this.dictionary,
                    formatAmount: formatAmountWrapper(this.currencyCodeMap, this.currencyFormatter, retrieverBet.currency),
                    dateFormatter: this.dateFormatter,
                    formatDateToFullMonthDayYear: this.formatDateToFullMonthDayYear,
                    openModal: this.openModal,
                    openPromosPage: this.openPromosPage,
                    retriever: this.retriever,
                    swooshFeatureFlag: this.swooshFeatureFlag,
                    swooshBaseUrl: this.swooshBaseUrl,
                    openBetOverMaxAmountModal: this.openBetOverMaxAmountModal,
                    locale: this.locale,
                });
                if (typeof bet !== "undefined") {
                    bets.push(bet);
                }
            }
            catch (e) {
                Tracker.getInstance().trackEvent(telemetry.events.myBetsError, {
                    Action: telemetry.actions.myBets.tryingToParseBets,
                    ClientType: telemetry.clientType,
                    betId: getTruthyValue(retrieverBet.betId, ""),
                    OriginalError: getErrorDescription(e),
                });
            }
        });
        return bets;
    }
    get status() {
        return this.retriever.status;
    }
}
//# sourceMappingURL=Parser.js.map